<div class="form-check">
  <input
    #checkbox
    class="form-check-input"
    type="checkbox"
    [id]="formConfig.id"
    [attr.name]="formConfig.name"
    [attr.aria-label]="formConfig.ariaLabel"
    [attr.ngbautofocus]="formConfig.autoFocus ? '' : undefined"
    (change)="onChange(checkbox.checked)"
    (blur)="onBlur($event)" />
  @if (formConfig.label) {
    <label class="form-check-label" [for]="formConfig.id">{{ formConfig.label }}</label>
  }
</div>
@if (displayErrorMessage()) {
  <div class="form-text">{{ errorMessage }}</div>
}
